var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "partner-slide",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-offset": "300",
      "data-aos-delay": "200",
      "data-aos-duration": "600"
    }
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._l(_vm.items, function (item) {
    return [_c('div', {
      key: item,
      staticClass: "swiper-slide"
    }, [_c('router-link', {
      staticClass: "partner-slide__box",
      attrs: {
        "to": item.to
      }
    }, [_c('div', {
      staticClass: "partner-slide__thumb"
    }, [_c('img', {
      attrs: {
        "src": item.src,
        "alt": item.name
      }
    })])])], 1)];
  })], 2), _vm._m(0)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "prev",
    attrs: {
      "type": "button"
    }
  }), _c('button', {
    staticClass: "next",
    attrs: {
      "type": "button"
    }
  })]);
}]

export { render, staticRenderFns }